import { Union } from "./.fable/fable-library.3.1.16/Types.js";
import { class_type, union_type } from "./.fable/fable-library.3.1.16/Reflection.js";
import { createElement } from "react";
import { round, equals, compare, createObj } from "./.fable/fable-library.3.1.16/Util.js";
import { cons, map, singleton, tryItem, ofArray, append } from "./.fable/fable-library.3.1.16/List.js";
import { toArray, map2, map as map_1, defaultArg } from "./.fable/fable-library.3.1.16/Option.js";
import { Interop_reactApi } from "./.fable/Feliz.1.51.0/Interop.fs.js";
import { nextId, middle } from "./Model.js";
import { printf, toText, replace, join } from "./.fable/fable-library.3.1.16/String.js";
import { PropHelpers_createSvgPathFloat } from "./.fable/Feliz.1.51.0/Properties.fs.js";
import { toList, tryFind } from "./.fable/fable-library.3.1.16/Map.js";
import { useReact_useEffectOnce_3A5B6456, useReact_useRef_1505 } from "./.fable/Feliz.1.51.0/React.fs.js";
import { singleton as singleton_1, append as append_1, delay, toList as toList_1, map as map_2, iterate } from "./.fable/fable-library.3.1.16/Seq.js";
import { rangeDouble } from "./.fable/fable-library.3.1.16/Range.js";

export class Orientation extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Vertical", "Horizontal"];
    }
}

export function Orientation$reflection() {
    return union_type("Patchy.Client.Orientation", [], Orientation, () => [[], []]);
}

function Util_cablePath(attrs) {
    return createElement("path", createObj(append(ofArray([["fill", "none"], ["strokeWidth", 5], ["strokeLinecap", "round"]]), attrs)));
}

function Util_rect(el) {
    return el.getBoundingClientRect();
}

function Util_cableColor(i) {
    return defaultArg(tryItem(i % 5, ofArray(["text-red-500", "text-yellow-500", "text-green-500", "text-blue-500", "text-indigo-500", "text-purple-500", "text-pink-500"])), "red-500");
}

function Util_chordD(_arg2_0, _arg2_1, _arg1_0, _arg1_1) {
    let patternInput, startX_1, patternInput_1, stopY_1;
    const _arg2 = [_arg2_0, _arg2_1];
    const _arg1 = [_arg1_0, _arg1_1];
    const startY = _arg2[1];
    const startX = _arg2[0];
    const stopY = _arg1[1];
    const stopX = _arg1[0];
    const minmax = (a, b) => {
        if (compare(a, b) <= 0) {
            return [a, b];
        }
        else {
            return [b, a];
        }
    };
    return ofArray([["M", singleton(ofArray([startX, startY]))], ["Q", ofArray([ofArray([(patternInput = minmax(startX, stopX), (startX_1 = patternInput[0], startX_1 + ((patternInput[1] - startX_1) / 2))), (patternInput_1 = minmax(startY, stopY), (stopY_1 = patternInput_1[1], stopY_1 + ((stopY_1 - patternInput_1[0]) / 2)))]), ofArray([stopX, stopY])])]]);
}

export class Controls {
    constructor() {
    }
}

export function Controls$reflection() {
    return class_type("Patchy.Client.Controls", void 0, Controls);
}

export function Controls_$ctor() {
    return new Controls();
}

export function Controls_Knob_2C675436(controls_Knob_2C675436InputProps) {
    const value = controls_Knob_2C675436InputProps.value;
    const onChange = controls_Knob_2C675436InputProps.onChange;
    const max = controls_Knob_2C675436InputProps.max;
    const min = controls_Knob_2C675436InputProps.min;
    const rotate = (((value - min) / (max - min)) * 300) + 210;
    const step = (max - min) / controls_Knob_2C675436InputProps.steps;
    return createElement("div", {
        className: "rounded-full w-9 h-9 shadow",
        onMouseDown: (e) => {
            e.target.requestPointerLock();
        },
        onMouseUp: (_arg1) => {
            document.exitPointerLock();
        },
        onMouseMove: (e_2) => {
            let value_1;
            if (equals(document.pointerLockElement, e_2.target)) {
                onChange((value_1 = (value - (round(e_2.movementY) * step)), (value_1 > max) ? max : ((value_1 < min) ? min : value_1)));
            }
        },
        children: Interop_reactApi.Children.toArray([createElement("svg", {
            className: "origin-center",
            viewBox: (((((0 + " ") + 0) + " ") + 10) + " ") + 10,
            style: {
                transform: ("rotate(" + rotate) + "deg)",
            },
            children: Interop_reactApi.Children.toArray([createElement("circle", {
                r: 5,
                cx: 5,
                cy: 5,
                fill: "#000000",
            }), createElement("line", {
                x1: 5,
                y1: 5,
                x2: 5,
                y2: 0.5,
                strokeLinecap: "round",
                stroke: "#FFFFFF",
            })]),
        })]),
    });
}

export class Components {
    constructor() {
    }
}

export function Components$reflection() {
    return class_type("Patchy.Client.Components", void 0, Components);
}

export function Components_$ctor() {
    return new Components();
}

export function Components_ControlList_6E3A73D(components_ControlList_6E3A73DInputProps) {
    const children = components_ControlList_6E3A73DInputProps.children;
    return createElement("ul", {
        className: "justify-evenly flex-wrap items-center w-full flex",
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function Components_BlankCell_53DCD2D1(components_BlankCell_53DCD2D1InputProps) {
    const onCloseMenu = components_BlankCell_53DCD2D1InputProps.onCloseMenu;
    const onOpenMenu = components_BlankCell_53DCD2D1InputProps.onOpenMenu;
    const onAddMod = components_BlankCell_53DCD2D1InputProps.onAddMod;
    const mods = components_BlankCell_53DCD2D1InputProps.mods;
    const gridArea = components_BlankCell_53DCD2D1InputProps.gridArea;
    const menuOpen = components_BlankCell_53DCD2D1InputProps.menuOpen;
    const blank = createElement("div", {
        style: {
            gridArea: gridArea,
        },
        className: "border-gray-200 border",
        onClick: (_arg1) => {
            onOpenMenu();
        },
    });
    if (menuOpen) {
        return createElement("div", {
            style: {
                gridArea: gridArea,
            },
            className: "overflow-y-auto",
            children: Interop_reactApi.Children.toArray([createElement("ul", {
                children: Interop_reactApi.Children.toArray(Array.from(cons(createElement("li", {
                    className: "text-right border border-gray-500",
                    onClick: (_arg2) => {
                        onCloseMenu();
                    },
                    children: Interop_reactApi.Children.toArray([createElement("span", {
                        title: "nevermind",
                        children: Interop_reactApi.Children.toArray(["☒"]),
                    })]),
                }), map((name_6) => createElement("li", {
                    className: "uppercase border-b border-l border-r border-gray-500 p-2",
                    onClick: (_arg3) => {
                        onAddMod(name_6);
                    },
                    children: Interop_reactApi.Children.toArray([name_6]),
                }), mods)))),
            })]),
        });
    }
    else {
        return blank;
    }
}

export function Components_Mod_4F7DC281(components_Mod_4F7DC281InputProps) {
    const onRemove = components_Mod_4F7DC281InputProps.onRemove;
    const controls = components_Mod_4F7DC281InputProps.controls;
    const name = components_Mod_4F7DC281InputProps.name;
    const gridArea = components_Mod_4F7DC281InputProps.gridArea;
    const header = createElement("header", {
        className: "flex border-b border-dashed border-gray-500 justify-between px-2 py-1",
        children: Interop_reactApi.Children.toArray([createElement("span", {
            className: "uppercase font-sans",
            children: name,
        }), createElement("div", {
            children: Interop_reactApi.Children.toArray([createElement("span", {
                onClick: (_arg4) => {
                    onRemove();
                },
                title: "remove module",
                children: "☒",
            })]),
        })]),
    });
    return createElement("div", {
        style: {
            gridArea: gridArea,
        },
        className: "flex border border-dashed border-gray-500 rounded-lg justify-between flex-col pb-2",
        children: Interop_reactApi.Children.toArray([header, controls]),
    });
}

export function Components_NewCable_Z5FEAA90F(components_NewCable_Z5FEAA90FInputProps) {
    let arg10;
    const cable = components_NewCable_Z5FEAA90FInputProps.cable;
    const color = components_NewCable_Z5FEAA90FInputProps.color;
    if (cable == null) {
        return null;
    }
    else {
        const stop = cable.cursor;
        const start = middle(cable.start[1]);
        return Util_cablePath(ofArray([["className", join(" ", ["duration-100 stroke-current", color])], ["style", {
            d: (arg10 = replace(PropHelpers_createSvgPathFloat(Util_chordD(start[0], start[1], stop[0], stop[1])), "\n", ""), toText(printf("path(\"%s\")"))(arg10)),
        }]]));
    }
}

export function Components_Cable_Z63792E3B(components_Cable_Z63792E3BInputProps) {
    const onClick = components_Cable_Z63792E3BInputProps.onClick;
    const cable = components_Cable_Z63792E3BInputProps.cable;
    const jackRefs = components_Cable_Z63792E3BInputProps.jackRefs;
    const jackIdToMiddle = (jackId) => map_1((arg) => middle(Util_rect(arg)), tryFind(jackId, jackRefs));
    return defaultArg(map2((start, stop) => Util_cablePath(ofArray([["pointerEvents", "visibleStroke"], ["d", PropHelpers_createSvgPathFloat(Util_chordD(start[0], start[1], stop[0], stop[1]))], ["className", join(" ", ["stroke-current", Util_cableColor(cable.id)])], ["onClick", onClick]])), jackIdToMiddle(cable.dest), jackIdToMiddle(cable.src)), null);
}

export function Components_Cables_Z13D0F5DF(components_Cables_Z13D0F5DFInputProps) {
    const onClick = components_Cables_Z13D0F5DFInputProps.onClick;
    const newCable = components_Cables_Z13D0F5DFInputProps.newCable;
    const cables = components_Cables_Z13D0F5DFInputProps.cables;
    const jackRefs = components_Cables_Z13D0F5DFInputProps.jackRefs;
    const nextColor = Util_cableColor(nextId(cables));
    return createElement("svg", {
        preserveAspectRatio: "none",
        className: "pointer-events-none absolute left-0 top-0 z-50 h-full w-full",
        children: Interop_reactApi.Children.toArray(Array.from(cons(createElement(Components_NewCable_Z5FEAA90F, {
            color: nextColor,
            cable: newCable,
        }), map((tupledArg) => {
            const cable = tupledArg[1];
            return createElement(Components_Cable_Z63792E3B, {
                jackRefs: jackRefs,
                cable: cable,
                onClick: (_arg5) => {
                    onClick(cable);
                },
            });
        }, toList(cables))))),
    });
}

export function Components_Scope_Z52BA71AE(components_Scope_Z52BA71AEInputProps) {
    let clo1, clo1_1;
    const key = components_Scope_Z52BA71AEInputProps.$key;
    const scope = components_Scope_Z52BA71AEInputProps.scope;
    const onRender = components_Scope_Z52BA71AEInputProps.onRender;
    const controls = components_Scope_Z52BA71AEInputProps.controls;
    const canvasRef = useReact_useRef_1505(void 0);
    useReact_useEffectOnce_3A5B6456((_arg1) => {
        iterate((arg) => {
            onRender(arg);
        }, toArray(canvasRef.current));
    });
    const range = scope.range;
    const ruler = (orientation, toLabel, min, max, step, wrapperStyle) => {
        const ticks = rangeDouble(min, (max - min) / (step - 1), max);
        const patternInput = (orientation.tag === 1) ? ["flex-row", "border-l h-1"] : ["flex-col", "border-t w-1"];
        const grooveStyle = patternInput[0];
        return createElement("div", {
            className: wrapperStyle,
            children: Interop_reactApi.Children.toArray([createElement("div", {
                className: join(" ", ["flex justify-between", grooveStyle]),
                children: Interop_reactApi.Children.toArray(Array.from(map_2((_arg7) => createElement("div", {
                    className: join(" ", ["border-gray-400", patternInput[1]]),
                }), ticks))),
            }), createElement("div", {
                className: join(" ", ["flex justify-between", grooveStyle]),
                children: Interop_reactApi.Children.toArray(Array.from(map_2((arg_1) => {
                    const label = toLabel(arg_1);
                    return createElement("span", {
                        className: "text-xs text-gray-600 text-center font-sans",
                        children: Interop_reactApi.Children.toArray([label]),
                    });
                }, ticks))),
            })]),
        });
    };
    const hTicks = ruler(new Orientation(1), (clo1 = toText(printf("%.3fs")), (arg10) => clo1(arg10)), 0, scope.frameDuration, 5, "col-start-1 col-end-1 row-start-2 row-end-2");
    const vTicks = ruler(new Orientation(0), (clo1_1 = toText(printf("%.1f")), (arg10_1) => clo1_1(arg10_1)), range, -1 * range, 5, "col-start-2 col-end-2 row-start-1 row-end-1 flex");
    return createElement("div", {
        style: {
            gridTemplateRows: join(" ", ["auto", 2 + "rem", 5 + "rem"]),
            gridTemplateColumns: join(" ", ["auto", 2 + "rem"]),
        },
        className: "h-full grid p-2",
        key: key,
        children: Interop_reactApi.Children.toArray([createElement("div", {
            className: "flex col-start-1 col-end-1 row-start-1 row-end-1",
            children: Interop_reactApi.Children.toArray([createElement("canvas", {
                className: "w-full h-full border border-dashed",
                ref: canvasRef,
            })]),
        }), vTicks, hTicks, createElement("div", {
            className: "col-start-1 col-span-2 row-start-3 row-end-3",
            children: Interop_reactApi.Children.toArray([createElement(Components_ControlList_6E3A73D, {
                children: controls,
            })]),
        })]),
    });
}

export function Components_Jack_Z1AD9156D(components_Jack_Z1AD9156DInputProps) {
    const key = components_Jack_Z1AD9156DInputProps.$key;
    const onRender = components_Jack_Z1AD9156DInputProps.onRender;
    const enabled = components_Jack_Z1AD9156DInputProps.enabled;
    const onMouseUp = components_Jack_Z1AD9156DInputProps.onMouseUp;
    const onMouseDown = components_Jack_Z1AD9156DInputProps.onMouseDown;
    const jack = components_Jack_Z1AD9156DInputProps.jack;
    const out = jack.out;
    const circle = "rounded-full border border-black";
    const center = "flex items-center justify-center";
    const ref = useReact_useRef_1505(void 0);
    useReact_useEffectOnce_3A5B6456((_arg2) => {
        iterate(onRender, toArray(ref.current));
    });
    return createElement("li", {
        className: join(" ", toList_1(delay(() => append_1(singleton_1(center), delay(() => append_1(out ? singleton_1("bg-black") : singleton_1("bg-white"), delay(() => append_1(enabled ? singleton_1("opacity-100") : singleton_1("opacity-50"), delay(() => singleton_1("m-1 flex-col transition-opacity duration-300 rounded-lg p-1")))))))))),
        key: key,
        onMouseDown: (_arg8) => {
            onMouseDown();
        },
        onMouseUp: (_arg9) => {
            onMouseUp();
        },
        children: Interop_reactApi.Children.toArray([createElement("span", {
            className: join(" ", toList_1(delay(() => append_1(singleton_1("text-xs font-sans mb-0.5 uppercase"), delay(() => (out ? singleton_1("text-white") : singleton_1("text-black"))))))),
            children: jack.label,
        }), createElement("div", {
            className: join(" ", [center, circle, "h-9 w-9 bg-white shadow"]),
            ref: ref,
            children: Interop_reactApi.Children.toArray([createElement("div", {
                className: join(" ", [center, circle, "h-7 w-7"]),
                children: Interop_reactApi.Children.toArray([createElement("div", {
                    className: join(" ", [circle, "h-5 w-5 bg-black"]),
                })]),
            })]),
        })]),
    });
}

